import React, { FC, useEffect, useState } from "react";
import "../../styles/homePage/table/TableFilters.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as Trash } from "../../common/assats/table/trash.svg";
import { ReactComponent as FiltersIcon } from "../../common/assats/table/FiltersIcon.svg";
import { ReactComponent as ExportIcon } from "../../common/assats/table/export.svg";
import { ReactComponent as ExportIconBig } from "../../common/assats/table/export-big.svg";
import { ReactComponent as Search } from "../../common/assats/table/search.svg";
import { ReactComponent as Plus } from "../../common/assats/table/plus.svg";
import { ReactComponent as VersionIcon } from "../../common/assats/input/update.svg";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useFilters } from "../../common/contexts/FiltersContext";
import { useLocation } from "react-router-dom";
import { canAccessRoute } from "../../common/function/roleRoutePermissions";
import useUserStore from "../../common/store/user.store";
import ExportSelection from "../common/ExportSelection";
import DynamicModal from "../common/Modal/DynamicModal";

const i18nPrefix = "table.filter";

export interface TableFiltersProps {
  tableHeadline?: string;
  trashAction?: () => void;
  filterAction?: () => void;
  searchValue?: string;
  setSearchValue?: (val: string) => void;
  searchPlaceholder?: string;
  buttonText?: string;
  buttonAction?: () => void;
  isExport?: boolean;
  exportAction?: (type: string) => void;
  filtersText?: string;
  createPath?: string;
  versionAction?: () => void;
  hideCheck?:boolean;
}
const TableFilters: FC<TableFiltersProps> = ({
  tableHeadline,
  trashAction,
  filterAction,
  searchValue,
  setSearchValue,
  searchPlaceholder,
  buttonText,
  buttonAction,
  isExport = false,
  exportAction,
  filtersText,
  createPath,
  versionAction,
}) => {
  const { t } = useTranslation();
  const { filtersCount } = useFilters();
  const filterTextContext = filtersText
    ? filtersText
    : t(`${i18nPrefix}.filters`);
  const [isAddDisabled, setIsAddDisabled] = React.useState(true);
  const location = useLocation();
  const { user } = useUserStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [exportType, setExportType] = useState<string | null>(null);

  useEffect(() => {
    setIsAddDisabledState();
  }, [location]);

  const setIsAddDisabledState = async () => {
    const role = user?.role;
    const path = createPath || location.pathname;
    const hasAccess = canAccessRoute(role, path);
    if (hasAccess) {
      setIsAddDisabled(false);
    }
  };

  const handleExportType = (selectedType: string) => {
    if (exportAction) {
      exportAction(selectedType);
    }
    setIsModalOpen(false);
  };

  const handleExportClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="table-filters-main-container">
      {tableHeadline && (
        <div className="title-wrapper">
          <label className="patients-list-title heading-h3">{tableHeadline}</label>
        </div>
      )}

      <div className="filters-wrapper">
        {trashAction && (
          <div onClick={trashAction} className="trash-button">
            <Trash  />
          </div>
        )}
        {filterAction && (
          <div
            onClick={filterAction}
            className={`filter-table-buttons filter-button  ${filtersCount ? "active-filters-button " : ""
              }`}
          >
            {filtersCount ? (
              <span className="filters-count">{filtersCount}</span>
            ) : null}
            <FiltersIcon onClick={filterAction} />
            <span className="filters-text">{filterTextContext}</span>
          </div>
        )}

        {isExport && (
          <>
            <div
              className=" filter-table-buttons export-button"
              onClick={handleExportClick}
            >
              <ExportIcon />
            </div>
            {isModalOpen && (
              <DynamicModal
                title="Export"
                icon={<ExportIconBig />}
                subtext="Select the file type to export:"
                onClose={handleModalClose}
                buttonText="general.buttons.export"
                onButtonClick={() => {
                  if (exportType) {
                    handleExportType(exportType);
                  }
                }}
              >
                <ExportSelection
                  onSelect={(t) => {
                    setExportType(t);
                  }}
                />
              </DynamicModal>
            )}
          </>
        )}

        {setSearchValue && (
          <Form.Group
            className="search-input-wrapper"
            controlId="formBasicEmail"
          >
            <InputGroup>
              <InputGroup.Text
                className="search-input"
                style={{ backgroundColor: "white", border: "none" }}
              >
                <Search />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder={searchPlaceholder}
                style={{ border: "none" }}
                className="search-input"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </InputGroup>
          </Form.Group>
        )}

        {
          versionAction && (
            <Button
              onClick={versionAction}
              className="version-table-buttons d-flex align-items-center justify-content-center gap-2"
              type="button"
            >
              <VersionIcon/>
              <span>{t("table.version.title")}</span>
            </Button>
          )
        }
        {buttonAction && buttonText && !isAddDisabled && (
          <Button
            onClick={buttonAction}
            className="add-button d-flex align-items-center justify-content-center gap-2"
            variant="primary"
            type="button"
          >
            <Plus />
            {buttonText}
          </Button>
        )}

      </div>
    </div>
  );
};

export default TableFilters;
